<template>
    <div class="d-flex flex-column h-100">
        <b-nav class="flex-grow-1" pills vertical>
            <b-nav-item
                    :key="index"
                    :link-classes="[item.icon && `mdi mdi-${item.icon}`]"
                    :class="inNavbar && 'in-navbar'"
                    :to="item.to"
                    exact-active-class="active"
                    active-class="active"
                    v-for="(item, index) in items"
            >
                {{ item.label }}
            </b-nav-item>
        </b-nav>
        <side-footer alternative class="mx-3" v-if="showFooter"/>
    </div>
</template>

<script>
    import SideFooter from "./Footer";

    export default {
        name: "AdminMenu",
        components: { SideFooter },
        props: {
            showFooter: {
                type: Boolean,
                default: true,
            },
            inNavbar: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                items: [
                    {
                        to: { name: 'PaymentsList' },
                        icon: 'credit-card-outline',
                        label: 'Pagos'
                    }
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    .nav-item {
        margin-left: 8px;
        a {
            &.nav-link {
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;

                &:not(.active) {
                    color: $brand-primary;
                }
            }
        }
        &.in-navbar {
            margin-left: 0;
            a {
                border-radius: 4px;
            }
        }
    }
</style>
